// Module
var code = "<div class=\"dates-area-container\"> <span class=\"label__text\"> Edited date(s) </span> <div ng-if=\"vm.event.excludedDays.length\"> <ng2-shared-chip-dates-list [event]=\"vm.event\"></ng2-shared-chip-dates-list> </div> <div ng-if=\"!vm.event.excludedDays.length\">None</div> </div> ";
// Exports
module.exports = code;